import { ValidationRules } from "aurelia-validation";
import { regexLibrary } from "../../common/utilities/regex-library";

export class PatientMessage {
    public recipientIds?: string[] = [];
    public sendToMessageCenter: boolean = false;
    public message: string = "";
    public messageDate: string = "";
    public messageTime: string = "";
    public assetId?: string = "";
    public title: string = "";

    public constructor(data?: PatientMessage) {
        if (!!data) {
            Object.assign(this, data);
        }
        this.initValidations();
    }

    public initValidations() {
        ValidationRules.ensure((patientMessage: PatientMessage) => patientMessage.messageDate)
            .required()
            .withMessage("Communication Note Date is required.")
            .ensure((patientMessage: PatientMessage) => patientMessage.messageTime)
            .required()
            .withMessage("Communication Note Time is required.")
            .satisfies(() => this.isValidTime())
            .withMessage("Selecting a future time is not allowed.")
            .then()
            .matches(regexLibrary.time)
            .withMessage("Invalid Time.")
            .ensure((patientMessage: PatientMessage) => patientMessage.title)
            .required()
            .withMessage("Enter a response.")
            .on(this);
    }

    private isValidTime() {
        if (!this.messageDate) {
            return true;
        }
        let currentDate = new Date();
        let enteredDate = new Date(`${this.messageDate} ${this.messageTime}`);
        return enteredDate <= currentDate;
    }
}
